import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer, CartesianGrid,
} from 'recharts';

class ComplianceBarchart extends PureComponent {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      Ejecutivo: PropTypes.string,
      Ejecucion: PropTypes.number,
      Meta: PropTypes.number
    })).isRequired,
  }

	render () {
      console.log(this.props.data)
  	return (
      <ResponsiveContainer height={600} width='100%'>
        <BarChart 
          width='100%'
          height={300}
          data={this.props.data}
          layout="vertical"
          margin={{top: 20, left: 10}}>
          <CartesianGrid strokeDasharray="1 1"/>
          <YAxis dataKey="Ejecutivo" //interval={0}
                 tick={{fontSize: 8}}
                 tickLine={false}
                 tickMargin={20}
                 type="category"
          />
          <XAxis type="number"/>
          <Tooltip/>
          <Legend />
          <Bar dataKey="Ejecucion" stackId="a" fill="#4AA400" />
          <Bar dataKey="Meta" stackId="a" fill="#BD0039" />

        </BarChart>
      </ResponsiveContainer>
    );
  }
}

export default ComplianceBarchart;
